import classNames from "classnames"
import React from "react"

type Props = {
  className?: string
  width?: number
  height?: number
  opacity?: number
  showBorder?: boolean
  dashClassName?: string
  borderClassName?: string
}

const CircleDashIcon = ({
  className,
  width = 20,
  height = 20,
  opacity = 0.3,
  showBorder = true,
  dashClassName = "stroke-current",
  borderClassName = "stroke-current",
}: Props) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        opacity={`${opacity}`}
        clipRule="evenodd"
        x="3.25"
        y={2.5}
        width="21"
        height="21"
        rx="13"
        className={classNames(showBorder ? borderClassName : "stroke-none")}
      />
      <path
        d="M9.83773 12.9999L17.83773 12.9999"
        strokeWidth="1.661"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={dashClassName}
      />
    </svg>
  )
}

export default CircleDashIcon
